import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import { AddressContainer } from '../../../../../../common/address/containers/address.container';
import FulfillmentProviderOUMComponent from './fulfillment-provider-oum.component';
import FulfillmentProvidersBasicInfoComponent from './fulfillment-provider-basic-info.component';

function FulfillmentProviderComponent({ id, stores, fullfillmentMethods, selectFulfillmentProvider, warehouses, back, handleFormSubmit, onInnerFormChange, organizationUnits, selectedAddress }: any) {
  const tabItems = [
    {
      id: 1,
      title: 'Basic Information',
      component: <FulfillmentProvidersBasicInfoComponent
        fullfillmentMethods={fullfillmentMethods}
        stores={stores}
        id={id}
        onInnerFormChange={onInnerFormChange}
        selectFulfillmentProvider={selectFulfillmentProvider}
        warehouses={warehouses}
      />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'Address',
      component: <AddressContainer
        onInnerFormChange={onInnerFormChange}
        selectedAddress={selectFulfillmentProvider}
      />,
      isVisible: true,
    },
    {
      id: 3,
      title: 'OUM Information',
      component: <FulfillmentProviderOUMComponent
        selectFulfillmentProvider={selectFulfillmentProvider}
        onInnerFormChange={onInnerFormChange}
        organizationUnits={organizationUnits}
      />,
      isVisible: true,
    }


  ]
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  );
}
export default FulfillmentProviderComponent;
